import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find } from '@fretadao/f-js-dom';

/**
 * Open a Modal for a given HTML id
**/
application.register('modal-by-id', class extends Controller {
  static values = { id: String };

  open(event) {
    event.preventDefault();
    const modal = this.application.getControllerForElementAndIdentifier(find(`#${this.idValue}`), 'modal');

    modal.open();
  }
});
